import {useSignal, useSignals} from '@preact/signals-react/runtime'
import classNames from 'classnames'
import {Button} from 'primereact/button'
import {Divider} from 'primereact/divider'
import {OverlayPanel} from 'primereact/overlaypanel'
import {Ripple} from 'primereact/ripple'
import React, {useCallback, useMemo, useRef} from 'react'
import {NavLink, useHistory} from 'react-router-dom'
import {Link} from 'react-router-dom/cjs/react-router-dom.min'
import {CSSTransition} from 'react-transition-group'
import safeStepLogo from '../src/assets/images/SafeStep.svg'
import {ReactComponent as Logo} from './assets/images/SafeStep.svg'
import {
    getSuperAdminRole,
    removeClientId,
    removeUserRole,
} from './components/authentication/AuthUtils'
import {chatEvent} from './components/chat/ChatService'
import {hospitalDisplaySettingType} from './components/hospital/HospitalConstant'
import HospitalOptions from './components/hospital/HospitalOptions'
import {useAppConfig} from './context/app/AppContext'
import {useUserHospital} from './context/hospital/UserHospitalContext'
import TranslateUtils from './i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from './utils/BlockScrollsUtils'
const AppSubmenu = ({isCollapsedSideBar = false, ...props}) => {
    useSignals()

    const activeIndex = useSignal(null)
    const history = useHistory()

    const {currentHospital, onChangeHospital} = useUserHospital()
    const {translateCommons} = TranslateUtils()
    const onMenuItemClick = (event, item, index) => {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault()
            return true
        }

        //execute command
        if (item.command) {
            item.command({originalEvent: event, item: item})
        }

        if (index === activeIndex.value) activeIndex.value = null
        else activeIndex.value = index

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item,
            })
        }
    }

    const onKeyDown = event => {
        if (event.code === 'Enter' || event.code === 'Space') {
            event.preventDefault()
            event.target.click()
        }
    }

    const renderLinkContent = useCallback(
        item => {
            return (
                <React.Fragment>
                    <div className=" w-full ">
                        <div
                            className={`${item.to} flex align-items-center py-1 gap-2 cursor-pointer transition-colors transition-duration-250 w-full `}
                            style={{
                                borderRadius: '10px',
                            }}
                            onClick={() => {
                                chatEvent.emit('MENU-CHANGE')
                                history.push(`${item.to}`)
                            }}>
                            <div className="">
                                {' '}
                                {item.iconComp ? (
                                    <item.iconComp />
                                ) : (
                                    <i className={`${item.icon} text-sm`}></i>
                                )}
                            </div>

                            <div
                                className={`${
                                    isCollapsedSideBar ? 'hidden' : ''
                                }  font-semibold text-md px-2`}>
                                {' '}
                                {item.label}
                            </div>
                            <Ripple />
                        </div>
                    </div>
                    <Ripple />
                </React.Fragment>
            )
        },
        [history, isCollapsedSideBar],
    )
    const renderLink = (item, i) => {
        let lowerCaseItemLabel = item.label ? item.label.toLowerCase() : ''
        let searchMenuValue = props.searchMenu
            ? props.searchMenu.toLowerCase()
            : ''

        if (!lowerCaseItemLabel.includes(searchMenuValue)) {
            return null
        }

        let content = renderLinkContent(item)
        return (
            <NavLink
                aria-label={item.label}
                onKeyDown={onKeyDown}
                role="menuitem"
                className={`p-ripple ${
                    (window.location.pathname?.length === 1 &&
                        item.to === '/') ||
                    (window.location.pathname?.length > 1 &&
                        window.location.pathname.includes(item.to) &&
                        item.to !== '/')
                        ? `router-link-active router-link-exact-active`
                        : ''
                } `}
                to={item.to}
                onClick={e => onMenuItemClick(e, item, i)}
                exact
                target={item.target}
                // onMouseEnter={e => {
                //     if (isCollapsedSideBar) {
                //         showOverlayTooltip(
                //             e,
                //             <h6
                //                 className="m-0 font-semibold"
                //                 style={{color: 'darkcyan'}}>
                //                 {item.label}
                //             </h6>,
                //             'right',
                //         )
                //     }
                // }}
                // onMouseLeave={e => {
                //     if (isCollapsedSideBar) {
                //         hideOverlayTooltip(e)
                //     }
                // }}
            >
                {content}
            </NavLink>
        )
    }

    let items =
        props.items &&
        // eslint-disable-next-line array-callback-return
        props.items.map((item, i) => {
            if (!item.hidden) {
                let active = activeIndex.value === i

                let styleClass = classNames(item.badgeStyleClass, {
                    'layout-menuitem-category': props.root,
                    'active-menuitem': active && !item.to,
                    'custom-nav-item': true,
                })
                if (props.root) {
                    return (
                        <li className={styleClass} key={i} role="none">
                            {props.root === true && (
                                <React.Fragment>
                                    <div
                                        className="layout-menuitem-root-text px-4 white-space-nowrap"
                                        aria-label={item.label}>
                                        {!isCollapsedSideBar ? item.label : ''}
                                    </div>

                                    <AppSubmenu
                                        searchMenu={props.searchMenu}
                                        items={item.items}
                                        isCollapsedSideBar={isCollapsedSideBar}
                                        onMenuItemClick={props.onMenuItemClick}
                                    />
                                </React.Fragment>
                            )}
                        </li>
                    )
                } else {
                    return (
                        <li className={styleClass} key={i} role="none">
                            {renderLink(item, i)}
                            <CSSTransition
                                classNames="layout-submenu-wrapper"
                                timeout={{enter: 1200, exit: 450}}
                                in={active}
                                unmountOnExit>
                                <AppSubmenu
                                    searchMenu={props.searchMenu}
                                    items={item.items}
                                    isCollapsedSideBar={isCollapsedSideBar}
                                    onMenuItemClick={props.onMenuItemClick}
                                />
                            </CSSTransition>
                        </li>
                    )
                }
            }
        })
    return items ? (
        <div
            className="overflow-y-auto"
            style={{}}
            onClick={unblockOverflownScroll}
            onMouseEnter={blockOverflownScroll}
            onMouseLeave={unblockOverflownScroll}>
            <ul
                className={`list-none p-2 m-0 flex flex-wrap gap-1 ${props.className} relative`}
                role="menu">
                {items}
            </ul>{' '}
        </div>
    ) : null
}

export const AppMenu = ({isCollapsed = false, ...props}) => {
    useSignals()
    const {userRole} = useAppConfig()
    const searchMenu = useSignal('')
    const hospitalsBelongRef = useRef()
    const history = useHistory()
    const {translateCommons} = TranslateUtils()
    const {currentHospital, onChangeHospital} = useUserHospital()
    const handleSearchMenu = useCallback(
        value => {
            searchMenu.value = value
        },
        [searchMenu],
    )

    const displaySetting = currentHospital?.displaySetting
    const hospitalLogo = useMemo(() => {
        if (!currentHospital || !currentHospital?.id) return null

        const hospitalName = currentHospital?.name
        const hospitalLogo = currentHospital?.logo

        switch (displaySetting) {
            case hospitalDisplaySettingType.imageOnly:
                return (
                    <img
                        className="h-4rem m-0 mr-2"
                        src={hospitalLogo}
                        alt="logo"
                        style={{
                            objectFit: 'contain',
                        }}
                    />
                )
            case hospitalDisplaySettingType.textOnly:
                return <Logo className="h-4rem w-9rem m-0" />
            case hospitalDisplaySettingType.textAndImage:
                return (
                    <img
                        className="h-4rem m-0 mr-2"
                        src={hospitalLogo}
                        alt="logo"
                        style={{
                            objectFit: 'contain',
                        }}
                    />
                )
            default:
                return <Logo className="h-4rem w-9rem m-0" />
        }
    }, [currentHospital, displaySetting])
    const iconSize = 20
    return (
        <>
            {' '}
            {/* <div className="absolute top-0 right-0 mt-3">
                {!props.mobileMenuActive && (
                    <div
                        className="p-ripple px-2 py-2 border-1 border-gray-200 bg-white border-circle cursor-pointer z-2 relative "
                        onClick={props.onMenuCollapsed}>
                        {' '}
                        {isCollapsed ? (
                            <DoubleRightIcon
                                height={iconSize}
                                width={iconSize}
                            />
                        ) : (
                            <DoubleLeftIcon
                                height={iconSize}
                                width={iconSize}
                            />
                        )}
                        <Ripple />
                    </div>
                )}
            </div> */}
            <div
                className={`layout-menu-container flex flex-column justify-content-between h-full relative`}>
                <div className="flex flex-column  h-5rem px-3 ">
                    <div className="w-full relative">
                        {' '}
                        <Link
                            to="/"
                            onClick={() =>
                                getSuperAdminRole() && removeClientId()
                            }
                            className="layout-topbar-logo col-12 flex align-items-center gap-1 py-3">
                            <div className="">
                                {' '}
                                <img
                                    className=""
                                    style={{width: '2.5rem'}}
                                    src={safeStepLogo}
                                />
                            </div>
                            {!isCollapsed && (
                                <h5 className="font-bold text-900 m-0 p-0 white-space-nowrap">
                                    Safe Step
                                </h5>
                            )}
                        </Link>
                    </div>
                </div>
                <div className="px-3 mt-2">
                    <div
                        className="p-2 flex gap-2 align-items-center border-1 border-gray-100 bg-gray-50 border-round-lg px-2 cursor-pointer"
                        onClick={e => {
                            hospitalsBelongRef.current.toggle(e)
                            blockOverflownScroll()
                        }}>
                        <div className="p-1 px-2">
                            <img
                                className="w-2rem h-2rem m-0  border-circle"
                                src={currentHospital?.logo || safeStepLogo}
                                alt={currentHospital?.name}
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </div>
                        {!isCollapsed && (
                            <div className="">
                                <h6 className="p-0 m-0 font-bold white-space-nowrap">
                                    {currentHospital?.name}
                                </h6>
                                <p className="white-space-nowrap">
                                    Change Facility
                                </p>
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className="relative overflow-scroll"
                    style={{height: 'calc(100vh - 12rem)'}}>
                    <AppSubmenu
                        items={props.model}
                        className="layout-menu"
                        onMenuItemClick={props.onMenuItemClick}
                        root={true}
                        isCollapsedSideBar={isCollapsed}
                        role="menu"
                        searchMenu={searchMenu.value}
                    />
                </div>
                <div className="p-2 text-center h-6rem ">
                    <Divider className="my-2" />

                    {!!getSuperAdminRole() ? (
                        <div className="px-3">
                            <Button
                                className="col-12 h-3rem px-3"
                                style={{
                                    backgroundColor: 'white',
                                    color: 'darkcyan',
                                }}
                                label={translateCommons('BACK TO ADMIN')}
                                icon="pi pi-arrow-circle-left"
                                onClick={() => {
                                    removeClientId()
                                    removeUserRole()
                                    history.push('/')
                                }}></Button>{' '}
                        </div>
                    ) : (
                        <p className="font-bold py-3">
                            Powered by ThinkShield Ltd.
                        </p>
                    )}
                </div>
            </div>
            <OverlayPanel
                ref={hospitalsBelongRef}
                className=""
                onShow={() => blockOverflownScroll()}
                onHide={() => unblockOverflownScroll()}>
                <HospitalOptions />
            </OverlayPanel>
        </>
    )
}
